module.exports = __webpack_public_path__ + "static/media/EBIT-BTC.8f74ffb3.svg";